import React, { useState } from 'react';
import SectionHeader from '../components/SectionHeader';
import Reveal from '../components/Reveal';
import { contact } from '../mock';
import { MapPin, Phone, Mail, Send } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const { toast } = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();
    // Save to localStorage for frontend-only demo
    const saved = JSON.parse(localStorage.getItem('safari_messages') || '[]');
    saved.push({ ...form, at: new Date().toISOString() });
    localStorage.setItem('safari_messages', JSON.stringify(saved));
    toast({ title: 'Message sent!', description: 'Our team will contact you shortly.' });
    setForm({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <div>
      <div className="relative h-[46vh] min-h-[340px] bg-cover bg-center" style={{ backgroundImage: `url(https://images.unsplash.com/photo-1682848310112-be63321ce3d0?crop=entropy&cs=srgb&fm=jpg&q=85)` }}>
        <div className="absolute inset-0 bg-[#1a1108]/70" />
        <div className="container-x relative z-10 h-full flex flex-col justify-center">
          <span className="eyebrow text-[#f0b040]">Get in Touch</span>
          <h1 className="font-display text-5xl md:text-6xl text-[#fff8ec] font-bold">Contact & Location</h1>
        </div>
      </div>

      <section className="section">
        <div className="container-x grid md:grid-cols-2 gap-14">
          <Reveal>
            <SectionHeader eyebrow="Reach Us" title="We’re Here to Help" subtitle="Have questions about safari timings, group bookings or educational tours? Send us a note." />
            <div className="space-y-5">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-[#fbf3e4] text-[#b8791c] flex items-center justify-center flex-shrink-0"><MapPin size={20} /></div>
                <div>
                  <div className="font-semibold text-[#2b1d0e]">Address</div>
                  <div className="text-sm text-[#5c4020]">{contact.address}</div>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-[#fbf3e4] text-[#b8791c] flex items-center justify-center flex-shrink-0"><Phone size={20} /></div>
                <div>
                  <div className="font-semibold text-[#2b1d0e]">Phone</div>
                  <div className="text-sm text-[#5c4020]">{contact.phone}</div>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-[#fbf3e4] text-[#b8791c] flex items-center justify-center flex-shrink-0"><Mail size={20} /></div>
                <div>
                  <div className="font-semibold text-[#2b1d0e]">Email</div>
                  <div className="text-sm text-[#5c4020]">{contact.email}</div>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={200}>
            <form onSubmit={handleSubmit} className="bg-white p-8 rounded-lg border border-[#e6d3b0] shadow-md space-y-4">
              <h3 className="font-display text-2xl text-[#2b1d0e]">Send a Message</h3>
              <div className="grid grid-cols-2 gap-4">
                <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Full name" className="px-4 py-3 border border-[#e6d3b0] rounded focus:outline-none focus:border-[#b8791c] text-sm" />
                <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" className="px-4 py-3 border border-[#e6d3b0] rounded focus:outline-none focus:border-[#b8791c] text-sm" />
              </div>
              <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="Phone (optional)" className="w-full px-4 py-3 border border-[#e6d3b0] rounded focus:outline-none focus:border-[#b8791c] text-sm" />
              <textarea required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Your message..." className="w-full px-4 py-3 border border-[#e6d3b0] rounded focus:outline-none focus:border-[#b8791c] text-sm resize-none" />
              <button type="submit" className="btn-primary w-full justify-center">
                Send Message <Send size={16} />
              </button>
            </form>
          </Reveal>
        </div>
      </section>

      <section className="pb-16">
        <div className="container-x">
          <div className="rounded-lg overflow-hidden border border-[#e6d3b0] shadow-md">
            <iframe
              title="map"
              src="https://maps.google.com/maps?q=Etawah%20Lion%20Safari&t=&z=13&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="420"
              style={{ border: 0 }}
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </div>
  );
}
